import { cn } from '@vidahealth/vida-ui';
import { View } from 'react-native';

/**
 * A 24px radio indicator — the border + inner dot flip to primary when selected.
 * Visual only (no press target / accessibility state); pair it as a child of a
 * `SelectableRow` with `selectionRole='radio'`, which owns the press + a11y.
 */
export function RadioDot({ selected }: { selected: boolean }) {
  return (
    <View
      className={cn(
        'h-6 w-6 items-center justify-center rounded-full border-2',
        selected ? 'border-primary-500' : 'border-outline-400'
      )}
    >
      {selected ? <View className='h-3 w-3 rounded-full bg-primary-500' /> : null}
    </View>
  );
}
